import Vue from "vue";
import Component from "vue-class-component";
import { Model, Prop } from "vue-property-decorator";

@Component
export default class StructBase extends Vue {
  @Model("input")
  protected value!: string;
  @Prop()
  protected level!: string;

  @Prop()
  protected function!: string;

  @Prop()
  protected parentId!: string;

  protected selected = "";
}
